/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const inviteListItemSchema = z.object({
  userId: z.optional(z.string()),
  email: z.optional(z.string()),
  role: z.optional(z.string()),
  expiresAt: z.optional(z.iso.datetime()),
  invitedAt: z.optional(z.iso.datetime()),
});
